<div required-payment
		 fxLayout="column"
		 fxLayoutAlign="center center">
	<div class="blur-box"></div>
	<mat-icon>lock</mat-icon>
	<p>Change your plan to unlock the result</p>
	<button mat-raised-button
					color='primary'>
		UPGRADE
	</button>
</div>
